'use client';

import { c as _c } from "react/compiler-runtime";
import { Dispatch, SetStateAction, useTransition } from 'react';
import { tableSortParser } from '../../query-parsers';
import type { SortingState } from '../tanstack-table';
import { useTableQueryState } from '../hooks/use-table-query-state.ts';
export const useTableSorting = t0 => {
  const $ = _c(15);
  const {
    onSortingChange,
    sorts: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sorts = t2;
  const [isSortPending, startTransition] = useTransition();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sort: tableSortParser
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    setValuesAndResetPage,
    values
  } = useTableQueryState(t3);
  let t4;
  if ($[3] !== sorts || $[4] !== values.sort) {
    t4 = values.sort ? values.sort.filter(sort => sorts.includes(sort.id)) : [];
    $[3] = sorts;
    $[4] = values.sort;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const sorting = t4;
  let t5;
  if ($[6] !== onSortingChange || $[7] !== setValuesAndResetPage || $[8] !== sorting || $[9] !== sorts) {
    t5 = sortingOrFn => {
      const newSorting = typeof sortingOrFn === "function" ? sortingOrFn(sorting) : sortingOrFn;
      let filteredSorting = newSorting.filter(sort_0 => sorts.includes(sort_0.id));
      if (filteredSorting.length > 1) {
        filteredSorting = [filteredSorting[filteredSorting.length - 1]];
      }
      setValuesAndResetPage({
        sort: filteredSorting.length > 0 ? filteredSorting : null
      }, {
        startTransition
      });
      onSortingChange?.(filteredSorting);
    };
    $[6] = onSortingChange;
    $[7] = setValuesAndResetPage;
    $[8] = sorting;
    $[9] = sorts;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const setSorting = t5;
  let t6;
  if ($[11] !== isSortPending || $[12] !== setSorting || $[13] !== sorting) {
    t6 = {
      isSortPending,
      setSorting,
      sorting
    };
    $[11] = isSortPending;
    $[12] = setSorting;
    $[13] = sorting;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};